/**
 * CONTACTOS DEL SITIO: edita los números únicamente en este archivo.
 * Usa código de país, sin espacios ni + (ejemplo Colombia: 573001234567).
 * Un campo vacío hereda el valor general. WhatsApp y teléfono son independientes.
 * Después de editar, vuelve a compilar y publicar el sitio.
 */
export const contactos = {
  general: {
    whatsapp: '573044875527',
    telefono: '573044875527',
  },
  inicio: { whatsapp: '', telefono: '' },
  internet: { whatsapp: '', telefono: '' },
  television: { whatsapp: '', telefono: '' },
  canal: { whatsapp: '', telefono: '' },
  envivo: { whatsapp: '', telefono: '' },
  catalogo: { whatsapp: '', telefono: '' },
  historia: { whatsapp: '', telefono: '' },
  pagos: { whatsapp: '', telefono: '' },
  normativa: { whatsapp: '', telefono: '' },
  politicaDatos: { whatsapp: '', telefono: '' },
  // Atención visible junto al formulario (antes usaba el número general).
  contacto: { whatsapp: '', telefono: '' },
  // Destino del envío del formulario PQRS; conserva el número existente.
  pqrs: { whatsapp: '573177089554', telefono: '' },
};
